import { useMemo } from 'react';

import { useConfiguration } from '@ocx-app/modules/configuration/useConfiguration';

import { CookieConsentProvider } from './cookie-consent.types';
import { CookiebotProvider } from './providers';

export const useCookieConsentProvider = () => {
  const {
    config: { cookieConsent },
  } = useConfiguration();

  const provider = useMemo<CookieConsentProvider | null>(() => {
    if (!cookieConsent || !cookieConsent.enabled || !cookieConsent.provider) return null;

    if (cookieConsent.provider === 'cookiebot') {
      return new CookiebotProvider({ sdkUrl: cookieConsent.sdkUrl });
    }

    // Add support for other providers here as needed

    return null;
  }, [cookieConsent]);

  return provider;
};
